// extracted by mini-css-extract-plugin
export default {"DeleteProjectHealthChecksDialog":"DeleteProjectHealthChecksDialog_DeleteProjectHealthChecksDialog__hT1ZB"};